import React, { useRef, useMemo } from 'react'
import { useSelector } from 'react-redux'
import AreaChart from '../AreaChart/AreaChart'
import Styles from './MarketGraphCard.module.css'
import UpArrow from './up-arrow.svg'
import DownArrow from './down-arrow.svg'

function MarketGraphCard({
  icon = null,
  coinName,
  price,
  priceChangePercentage = 0,
  containerStyle,
  marketKLine = {},
  pairId
}) {
  const theme = useSelector(state => state.theme.value)
  const coinNameContainerRef = useRef(null)

  // Memoize the data conversion to prevent unnecessary recalculations
  const kLineData = useMemo(() => {
    return marketKLine?.map?.(subArr => subArr[2]) || []
  }, [marketKLine])

  // Memoize the price change calculation
  const isPricePositive = useMemo(() => {
    return priceChangePercentage > 0
  }, [priceChangePercentage])

  return (
    <div
      className={Styles.cardContainer}
      style={{
        backgroundColor: theme === 'light' && 'white',
        ...containerStyle
      }}
    >
      {/* info container */}
      <div className={Styles.infoContainer}>
        {/* icon + name container */}
        <div ref={coinNameContainerRef} className={Styles.coinNameContainer}>
          {icon && <img src={icon} />}
          <span
            style={{
              fontSize: 12.25
            }}
          >
            {coinName}
          </span>
        </div>

        {/* details container */}
        <div className={Styles.detailsContainer}>
          {price && (
            <span className={Styles.coinPrice}>
              <span className={Styles.approxSymbol}>≈</span>
              {price}
            </span>
          )}
          <div className={Styles.changePercentageContainer}>
            {priceChangePercentage !== 0 && (
              <>
                <span className={`${priceChangePercentage[0] === '+' ? Styles.positiveChange : Styles.negativeChange}`}>
                  {priceChangePercentage}
                </span>
                <img src={priceChangePercentage[0] === '+' ? UpArrow : DownArrow} />
              </>
            )}
          </div>
        </div>
      </div>

      {/* Graph container */}
      <div className='graph-container'>
        <AreaChart kLineData={kLineData} theme={theme} />
      </div>
    </div>
  )
}

export default React.memo(MarketGraphCard)
